import { Artist as GQLItem } from '../../generated/graphql';
import * as ArtistLink from './ArtistLink';
import * as ArtistAttachment from './ArtistAttachment';
import { take } from '../../util';
import { z } from 'zod';

export const artistSchema = z.object({
  id: z.number().optional(),
  name: z.string(),
  bio: z.string().optional(),
  links: z.array(ArtistLink.artistLinkSchema).optional().default([]),
  attachments: z.array(ArtistAttachment.artistAttachmentSchema).optional().default([]),
});

export type Artist = z.infer<typeof artistSchema>;

export const fromGql = (item: GQLItem): Artist => ({
  ...take<Artist>(item, 'id', 'name', 'bio'),
  links: item.links ? ArtistLink.fromGqlCollection(item.links) : [],
  attachments: item.attachments ? ArtistAttachment.fromGqlCollection(item.attachments) : [],
});

export const fromGqlCollection = (items: GQLItem[]): Artist[] => (items || []).map(item => fromGql(item));
